// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3k6LZ","choiceBoxes":"toolbarselects_choiceBoxes__3DCM-","simpleField":"toolbarselects_simpleField__1VoYb"};